/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of group contract:
 * - G (Group): single subscriber for all members (alimente contracts inherit subscriber)
 * - C (Cadre): each member has its own subscriber
 * 
 * @export
 */
export const GroupContractType = {
    Group: 'G',
    Cadre: 'C'
} as const;
export type GroupContractType = typeof GroupContractType[keyof typeof GroupContractType];


export function instanceOfGroupContractType(value: any): boolean {
    for (const key in GroupContractType) {
        if (Object.prototype.hasOwnProperty.call(GroupContractType, key)) {
            if (GroupContractType[key as keyof typeof GroupContractType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GroupContractTypeFromJSON(json: any): GroupContractType {
    return GroupContractTypeFromJSONTyped(json, false);
}

export function GroupContractTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupContractType {
    return json as GroupContractType;
}

export function GroupContractTypeToJSON(value?: GroupContractType | null): any {
    return value as any;
}

export function GroupContractTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): GroupContractType {
    return value as GroupContractType;
}

